var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_downward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_6997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_6997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_downward_2",
    d: "M11.5 4V16.175L5.9 10.575L4.5 12L12.5 20L20.5 12L19.1 10.575L13.5 16.175V4H11.5Z",
    fill: "#4D2481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.04fc503b6fbaa11e3d00c08ffac6aa2c.svg";
export { ForwardRef as ReactComponent };